export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
        "abbr": ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
      },
      "days": {
        "full": ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
        "abbr": ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
      },
      "patterns": {
        "longtime": "HH:mm:ss",
        "birthdate": "dd/MM/yyyy",
        "shorttime": "HH:mm",
        "shortdate": "dd/MM HH:mm",
        "shortday": "dd MMM",
        "fulldate": "dd/MM/yyyy HH:mm"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["(Sn)", "Sn"],
        "blinds": "Ss-b"
      },
      "group": {
        "separator": ",",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ".",
        "length": 2
      },
      "ordinal": function(number) { var b = number % 10; return number + ((number % 100 / 10) === 1 ? 'th' : (b === 1) ? 'st' : (b === 2) ? 'nd' : (b === 3) ? 'rd' : 'th'); }
    }
  },
  "translations": {
    messages: {
  "Challenges": [
    null,
    "Challenges"
  ],
  "Close": [
    null,
    "Close"
  ],
  "Guarantee": [
    null,
    "Guarantee"
  ],
  "Name": [
    null,
    "Name"
  ],
  "Next level": [
    null,
    "Next level"
  ],
  "No data": [
    null,
    "No data"
  ],
  "Points": [
    null,
    "Points"
  ],
  "Potential winnings": [
    null,
    "Potential winnings"
  ],
  "Rank": [
    null,
    "Rank"
  ],
  "to be shared out every day!": [
    null,
    "to be shared out every day!"
  ]
}
  }
}
